import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { Button } from 'react-bootstrap';
import { LanguagesFetchAPI } from '../../api/Languages';
import LoadingAlert from '../Alerts/LoadingAlert';
import './BranchSelect.css'


/* Íconos idénticos al primer modal para que se vean iguales */
const IcoStore = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l1.5-5h15L21 9" /><path d="M3 9a3 3 0 0 0 6 0 3 3 0 0 0 6 0 3 3 0 0 0 6 0" /><path d="M4 11v9h16v-9" /><path d="M10 20v-5h4v5" /></svg>;
const IcoAll = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7" rx="1.5" /><rect x="14" y="3" width="7" height="7" rx="1.5" /><rect x="14" y="14" width="7" height="7" rx="1.5" /><rect x="3" y="14" width="7" height="7" rx="1.5" /></svg>;
const IcoX = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>;
const IcoInfo = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>;
const IcoCheck = () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>;
const IcoCaret = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9" /></svg>;

// This component is used to select the branchoffice of the user, it is used in the NavBar and in the reports, it is a modal that shows the list of branchoffices of the user and allows to select one, it also allows to select all the branchoffices.
function ModalBranchofficeSelect({ actionSelectBranches }) {
    /* lógica 100% original */
    const [selectedBranches, setSelectedBranches] = useState([]);
    const [allSelected, setAllSelected] = useState(true);
    const [branchofficeName, setBranchofficeName] = useState("Todas las sucursales");
    const [showModalBranchofficeslect, setShowModalBranchofficesselect] = useState(false);
    const [statusLanguage, setStatusLanguage] = useState(0)

    //We get the user data
    let user = JSON.parse(localStorage.getItem('user'))
    let token = localStorage.getItem('x-access-token');
    const [userBranchoffices, setUserBranchs] = useState([]);

    //Helpers
    const toggleBranch = (branch) => {
        const exists = selectedBranches.find(b => b.code === branch.code);

        let updated = [];

        if (exists) {
            updated = selectedBranches.filter(b => b.code !== branch.code);
        } else {
            updated = [...selectedBranches, branch];
        }

        setSelectedBranches(updated);
        setAllSelected(false);
    };

    // This function is used to confirm the selection of the branchoffices, it is called when the user clicks on the confirm button, it saves the selected branchoffices in the localStorage and calls the actionSelectBranches function with the selected branchoffices.
    const confirmSelection = () => {
        if (allSelected || selectedBranches.length === 0) {
            localStorage.setItem("report_branchoffices_mode", "all");
            localStorage.setItem("report_branchoffices", JSON.stringify([]));
            setBranchofficeName("Todas las sucursales");
            actionSelectBranches([]);
        } else {
            localStorage.setItem("report_branchoffices_mode", "custom");
            localStorage.setItem("report_branchoffices", JSON.stringify(selectedBranches));
            setBranchofficeName(
                selectedBranches.length === 1
                    ? selectedBranches[0].branchoffice_name
                    : `${selectedBranches.length} sucursales`
            );
            actionSelectBranches(selectedBranches);
        }

        setShowModalBranchofficesselect(false);
    };

    {/*view branchoffice*/ }
    const viewBranch = () => {
        const listItems = userBranchoffices.map((branch, index) => {
            const isChecked = selectedBranches.some(b => b.code === branch.code);
            return (
                <div className={`mbs-branch-item${isChecked ? ' is-current' : ''}`} key={index}>
                    <input
                        type="checkbox"
                        className="btn-check"
                        id={branch.branchoffice_name + index}
                        checked={isChecked}
                        onChange={() => toggleBranch(branch)}
                    />
                    <label
                        className="mbs-branch-label btn-branchs card-title rounded-3 p-2 border border-primary text-center fw-semibold w-100 text-primary"
                        translate="no"
                        htmlFor={branch.branchoffice_name + index}
                    >
                        <div className="mbs-branch-label-ico"><IcoStore /></div>
                        <div className="mbs-branch-label-body">
                            <span className="mbs-branch-label-text">{branch.branchoffice_name}</span>
                            <span className="mbs-branch-label-sub">Sucursal</span>
                        </div>
                        <span className="mbs-pill">Activa</span>
                        <div className="mbs-branch-label-check is-square"><IcoCheck /></div>
                    </label>
                </div>
            );
        });
        return (listItems);
    }

    useEffect(() => {
        try {
            setUserBranchs(user.branchoffices || []);

            const mode = localStorage.getItem("report_branchoffices_mode");
            const stored = JSON.parse(localStorage.getItem("report_branchoffices") || "[]");

            if (mode === "custom" && stored.length > 0) {
                setAllSelected(false);
                setSelectedBranches(stored);
                setBranchofficeName(
                    stored.length === 1 ? stored[0].branchoffice_name : `${stored.length} sucursales`
                );
                actionSelectBranches(stored);
            } else {
                setAllSelected(true);
                setSelectedBranches([]);
                setBranchofficeName("Todas las sucursales");
                actionSelectBranches([]);
            }
        } catch (err) { }
    }, []);

    /* meta reactiva (mientras el modal está abierto refleja la selección en vivo) */
    const selectionSummary = allSelected || selectedBranches.length === 0
        ? "Todas las sucursales"
        : selectedBranches.length === 1
            ? selectedBranches[0].branchoffice_name
            : `${selectedBranches.length} sucursales seleccionadas`;

    return (
        <>
            {/* ── TRIGGER ── */}
            <button
                className="mbs-trigger"
                onClick={() => (setShowModalBranchofficesselect(true), console.log(userBranchoffices))}
            >
                <span className="mbs-trigger-ico"><IcoStore /></span>
                <span className="mbs-trigger-body">
                    <small className="mbs-trigger-label d-block fw-semibold" role="button">Sucursal</small>
                    <span className="mbs-trigger-name fw-semibold" role="button">
                        {branchofficeName}
                    </span>
                </span>
                <span className="mbs-trigger-caret"><IcoCaret /></span>
            </button>

            {/* ── MODAL ── */}
            <Modal
                centered
                className="modal-dialog-kk"
                size="md"
                show={showModalBranchofficeslect}
                onHide={() => setShowModalBranchofficesselect(false)}
                dialogClassName="mbs-dialog"
            >
                <Modal.Body>

                    {/* header: título + contador + cerrar */}
                    <div className="mbs-head">
                        <div className="mbs-head-title">
                            <h2 className="mbs-title">Sucursales</h2>
                            <span className="mbs-count">{userBranchoffices.length}</span>
                        </div>
                        <button
                            className="mbs-icon-btn mbs-icon-btn--danger" type="button" title="Cerrar" aria-label="Cerrar"
                            onClick={() => setShowModalBranchofficesselect(false)}
                        >
                            <IcoX />
                        </button>
                    </div>

                    {/* meta: selección actual */}
                    <div className="mbs-meta">
                        <span className="mbs-meta-key">Selección actual</span>
                        <span className="mbs-meta-val">
                            <span className="mbs-meta-dot" />
                            {selectionSummary}
                        </span>
                    </div>

                    {/* lista */}
                    <div className="mbs-section">
                        <div className="mbs-section-head">
                            <span className="mbs-section-label">Elige una o más sucursales</span>
                            <span className="mbs-section-count">
                                {allSelected ? `${userBranchoffices.length} de ${userBranchoffices.length}` : `${selectedBranches.length} de ${userBranchoffices.length}`}
                            </span>
                        </div>
                        <div className="mbs-list">
                            {/* "Todas" — lógica original intacta */}
                            <div className={`mbs-branch-item all-item${allSelected ? ' is-current' : ''}`}>
                                <input
                                    type="checkbox"
                                    className="btn-check"
                                    id="all-mbs-multi"
                                    checked={allSelected}
                                    onChange={() => {
                                        setAllSelected(true);
                                        setSelectedBranches([]);
                                    }}
                                />
                                <label
                                    className="mbs-branch-label btn-branchs card-title rounded-3 p-2 border border-primary text-center fw-semibold w-100 text-primary"
                                    htmlFor="all-mbs-multi" role="button"
                                >
                                    <div className="mbs-branch-label-ico"><IcoAll /></div>
                                    <div className="mbs-branch-label-body">
                                        <span className="mbs-branch-label-text">Todas las sucursales</span>
                                        <span className="mbs-branch-label-sub">Selecciona el conjunto completo</span>
                                    </div>
                                    <span className="mbs-pill">Activa</span>
                                    <div className="mbs-branch-label-check is-square"><IcoCheck /></div>
                                </label>
                            </div>
                            {/* viewBranch() — lógica original intacta */}
                            {viewBranch()}
                        </div>
                    </div>

                    {/* footer: hint + Aplicar */}
                    <div className="mbs-foot mbs-foot--actions">
                        <span className="mbs-foot-hint">
                            <IcoInfo /> Selecciona una o más sucursales
                        </span>
                        <button
                            type="button"
                            className="mbs-btn mbs-btn--primary"
                            onClick={confirmSelection}
                        >
                            <IcoCheck /> Aplicar
                        </button>
                    </div>

                    {/* estructura original oculta — preserva clases del proyecto y el Button de react-bootstrap */}
                    <div style={{ display: 'none' }}>
                        <div className="idioma-sp position-relative">
                            <section className="form-signin-sp bg-white border-0">
                                <h2 className="title-main-login text-center"><i className="uil uil-store-alt" />Sucursales</h2>
                                <div className="pb-4">
                                    <label className="form-label fw-normal text-gray-600">Lista de sucursales</label>
                                    <div className="branch-wrapper no-scroll">
                                        <div className="d-flex flex-column gap-3 p-2 bg-body">
                                            <Button onClick={confirmSelection}>Aplicar</Button>
                                        </div>
                                    </div>
                                    <div className="d-block text-center mt-3 opacity-50">
                                        <i className="uil uil-info-circle" /> Escoge la sucursal de tu preferencia.
                                    </div>
                                </div>
                            </section>
                            <div className="position-absolute top-0 start-100 translate-middle mt-2">
                                <div className="me-3">
                                    <button className="btn btn-outline-secondary border-0 bg-light text-secondary rounded-circle p-2 lh-1" type="button" onClick={() => setShowModalBranchofficesselect(false)} title="Cerrar">
                                        <i className="uil uil-multiply" /><span className="visually-hidden">Dismiss</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                </Modal.Body>
            </Modal>

            {void [LanguagesFetchAPI, LoadingAlert, statusLanguage, token]}
        </>
    )
}

export default ModalBranchofficeSelect